import { render } from "./ContactDetailsCompaniesTab.vue?vue&type=template&id=708e0165"
import script from "./ContactDetailsCompaniesTab.vue?vue&type=script&lang=js"
export * from "./ContactDetailsCompaniesTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__